import { Injectable } from '@angular/core';
import { child, push, ref } from '@angular/fire/database';
import { DatabaseService } from './database.service';

@Injectable({ providedIn: 'root' })
export class PushIdService {
  constructor(private dbSrv: DatabaseService) {}
  /**
   * Get next id from firebase realtime database
   * @return {string} Database id
   */
  public create(): string {
    // TODO: @Aandrzejmi prefix + createFilename()
    return push(child(ref(DatabaseService.getCommonDbRef(this.dbSrv)), '_')).key!;
  }
}
